import React, { Component } from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import * as ItemTypes from "../../../redux/items/types"
import { DckSelectors, DckActionCreators } from "dck-redux"
import ProcessTypes from "../../../redux/processes/types"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"

import UserTable from "../UserTable"
import FontAwesome from "react-fontawesome"
import { Link } from "react-router"
import { BooleanStatuses, selectFiltersFromStore } from "../../../lib/utils"
import ClearFiltersButton from "../../fragments/ClearFiltersButton"
import UIAvatar from "../../fragments/UIAvatar"

class ListUsers extends Component {

  componentDidMount() {
    this.props.loadUsers()
  }

  renderItemToRemove = item => item.username

  selectedHandler = id => this.props.setSelectedUser(id)

  doClearFilters = () => {
    this.refs.username.cleanFiltered()
    this.refs.name.cleanFiltered()
    this.refs.phoneNumber.cleanFiltered()
    this.refs.userRole.cleanFiltered()
    this.refs.active.cleanFiltered()
  }

  render() {
    const { users, removeUsers, router, userRoleFilters } = this.props

    return (
      <div>

        <ClearFiltersButton onClick={ this.doClearFilters } />

        <UserTable
          items={ users }
          onConfirmRemoval={ removeUsers }
          renderItemToRemove={ this.renderItemToRemove }
          addNewLabel="New user"
          addNewHandler={() => router.push({ pathname: "/users/add" })}
          selectedHandler={ this.selectedHandler }
        >
          <TableHeaderColumn
            dataField="id"
            isKey={true}
            dataAlign="center"
            dataFormat={(_, row) => <UIAvatar name={ row.name } size={ 28 } />}
            csvHeader="User ID"
            width='48'
          />

          <TableHeaderColumn
            ref='username'
            dataField="username"
            dataSort={true}
            filter={{ type: "TextFilter", delay: 1000 }}
            dataFormat={(username, row) =>
              <Link to={`/users/${row.id}/edit`} title='Show details'>{ username }</Link>}
            csvHeader="Email"
            columnClassName="min-w-120"
          >
            Email
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='name'
            dataField="name"
            dataSort={true}
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="Name"
            columnClassName="min-w-120"
          >
            Name
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='phoneNumber'
            dataField="phoneNumber"
            dataSort={true}
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="Phone number"
            columnClassName="min-w-120"
          >
            Phone number
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='userRole'
            dataField="userRole"
            dataAlign="center"
            dataSort={true}
            filter={{ type: "SelectFilter", options: userRoleFilters }}
            csvHeader="Role"
            width="200"
          >
            Role
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='active'
            dataField="active"
            dataAlign="center"
            dataSort={true}
            filter={{ type: "SelectFilter", options: BooleanStatuses }}
            dataFormat={active => <FontAwesome
              title={ active ? 'Active' : 'Inactive' } 
              style={{color: active ? 'green' : '#a66'}} 
              name={ active ? 'check' : 'close' } />
            }
            csvHeader="Active"
            width="120"
          >
            Active
          </TableHeaderColumn>

          <TableHeaderColumn
            dataAlign="center"
            width="80px"
            tdStyle={{ verticalAlign: 'middle' }}
            dataFormat={(_, row) => <span className="flex-detail">
              <Link to={`/users/${row.id}/edit`} className='p-5'>
                <FontAwesome name="pencil" className="blue cursor-pointer" title='Update' />
              </Link>
            </span>}
          />
        </UserTable>
      </div>
    )
  }
}

const mapStateToProps = state => {

  const mapping = {
    users: DckSelectors.selectAllItems(state, ItemTypes.User),
    usersLoading: DckSelectors.selectProcessRunning(state, ProcessTypes.USERS_LOAD),
    usersLoadingFailed: DckSelectors.selectProcessFailed(state, ProcessTypes.USERS_LOAD),
    usersRemoving: DckSelectors.selectProcessRunning(state, ProcessTypes.USERS_REMOVE),
    usersRemovingFailed: DckSelectors.selectProcessFailed(state, ProcessTypes.USERS_REMOVE),
    userRoleFilters: selectFiltersFromStore(state, ItemTypes.UserRoleFilter),
  }

  return mapping
},

mapDispatchToProps = dispatch => ({
  loadUsers: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.User)),
  removeUsers: id => dispatch(DckActionCreators.itemRemove(ItemTypes.User, id)),
  setSelectedUser: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.User, id))
})

export default connect(mapStateToProps, mapDispatchToProps)(ListUsers)



// WEBPACK FOOTER //
// ./src/components/Users/List/index.js